<template>
  <div class="photography">
    <transition appear @before-enter="beforeEnter" @enter="enter">
      <h2 data-index="2">My Captured Photos:</h2>
    </transition>
    <div v-if="modalImg">{{ modalImg.alt }}</div>
    <div id="myModal" class="modal" v-if="modalImg" @click="closeModel">
      <span class="close">&times;</span>
      <h2 id="caption">{{ modalImg.alt }}</h2>
      <img class="modal-content" :src="modalImg.src" :alt="modalImg.alt" />
    </div>
    <transition appear @before-enter="beforeEnterBox" @enter="enterBox">
      <div class="photos">
        <img
          v-for="img in data"
          :key="img.id"
          :src="img.src"
          :alt="img.alt"
          @click="() => (modalImg = img)"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import { ref } from "vue";
import getData from "../../composables/getData";
export default {
  props: {
    beforeEnter: Function,
    enter: Function,
    beforeEnterBox: Function,
    enterBox: Function,
  },
  setup() {
    const modalImg = ref(null);
    const closeModel = (event) => {
      event.target.className !== "modal-content" && (modalImg.value = null);
    };
    const { data, error, fetchData } = getData(process.env.VUE_APP_ALBUMS_URL);
    fetchData();
    return {
      modalImg,
      closeModel,
      data,
      error,
      fetchData,
    };
  },
};
</script>
<style scoped>
.modal {
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 1rem 0;
  position: fixed;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
}
.modal-content {
  width: 90%;
  margin: auto;
  display: block;
  max-width: 700px;
}
#caption {
  width: 80%;
  margin: auto;
  padding: 1rem 0;
  max-width: 700px;
  text-align: center;
  color: var(--yellow);
  text-transform: capitalize;
}
.close {
  top: 15px;
  right: 35px;
  font-size: 40px;
  transition: 0.3s;
  color: #f1f1f1;
  font-weight: bold;
  position: absolute;
}
.close:hover,
.close:focus {
  cursor: pointer;
  color: var(--red);
  text-decoration: none;
}
.photos {
  line-height: 0;
  column-count: 4;
  column-gap: 6px;
}
.photos img {
  cursor: pointer;
  margin-top: 3px;
  transition: 0.3s;
  margin-bottom: 3px;
  border-radius: 10px;
}
.photos img:hover {
  opacity: 0.85;
}
/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}
@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@media screen and (max-width: 1000px) {
  .photos {
    -moz-column-count: 3;
    -webkit-column-count: 3;
    column-count: 3;
  }
}
@media screen and (max-width: 800px) {
  .modal-content {
    width: 100%;
  }
  .photos {
    -moz-column-count: 2;
    -webkit-column-count: 2;
    column-count: 2;
  }
}
@media screen and (max-width: 400px) {
  .photos {
    -moz-column-count: 1;
    -webkit-column-count: 1;
    column-count: 1;
  }
}
</style>
